import { ILastIds } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

// 이미지 업로드에 이용할 마지막 이미지 아이디 및 마지막 시퀀스 아이디 불러오기
async function getImageUploaderLastIds(): Promise<AxiosResponse<FetchResult<ILastIds>>> {
  const response = await instance.get(`/images/last-ids`);
  return response;
}

const useFetchImageUploaderLastIds = () => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/admin/images/last-ids`],
    queryFn: () => getImageUploaderLastIds(),
    retry: false,
    refetchOnWindowFocus: false
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchImageUploaderLastIds;
